import { clsx } from 'clsx'
import { type FC, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { useOptionalProductCarouselFocus } from '../../ProductCarouselGalleryWithThumbnails/ProductCarouselFocusContext'

import { type ProductCarouselDotNavigationProps } from './ProductCarouselDotNavigationProps'

const ProductCarouselDotNavigation: FC<ProductCarouselDotNavigationProps> = ({
  className,
  currentIndex,
  dotCount,
  onClick,
}) => {
  const intl = useIntl()

  const mediaToRender = useMemo(
    () => Array.from({ length: dotCount }).keys().toArray(),
    [dotCount],
  )

  const focusContext = useOptionalProductCarouselFocus()

  return (
    <div
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className={clsx(
        'flex w-[calc(100vw-15px)] justify-center overflow-hidden tablet:w-auto',
        className,
      )}
    >
      {mediaToRender.map((counter, index) => (
        <button
          aria-label={intl.formatMessage(
            {
              id: 'general.label.product.carousel.image.index',
            },
            { productIndex: index + 1 },
          )}
          className={clsx(
            'mx-2 size-3.5 shrink-0 rounded-full border-2 border-dark-pressed-brand',
            currentIndex === index && 'bg-dark-pressed-brand',
          )}
          key={counter}
          onClick={(): void => {
            onClick(index)
          }}
          onKeyDown={(event): void => {
            if (event.key === 'Enter') {
              focusContext?.focusItem(index)
            }
          }}
          type="button"
        />
      ))}
    </div>
  )
}

export { ProductCarouselDotNavigation }
